import { GATEWAY_URL, ENV } from "../env";
import request from "./Request";

class TriggerActionService {

    static async sendTriggerAction(actionName, trigger, meta) {        
        try {
            const response = await request.POST(`${GATEWAY_URL}/ClientAction/TriggerAction`, {
                ActionName: actionName,
                Trigger: trigger,
                TriggerType: "Automatic",
                Meta: meta
            });

            // Check if response is ok
            if (response.status !== true) {
                console.log(`[TriggerActionService] Error sending trigger '${actionName}': ${response.StatusCode} - ${response.Message}`);
                return;
            } 
            console.log(`[TriggerActionService] Sent event '${actionName}' successfully!`);
        } catch (error) {
            console.error(`[TriggerActionService] Error sending trigger '${actionName}':`,error);
        }
    }
    
}

export default TriggerActionService;
